import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  class: "icon",
  focusable: "false"
}

import ButtonText from '@/design-system/atoms/buttons/ButtonText.vue'
import { Action } from './types'
import TooltipStandardV2 from '@/design-system/atoms/TooltipStandardV2.vue'
import { useI18n } from 'vue-i18n'
import { computed, ref, toRefs } from 'vue'
import ChevronToggle from '@/design-system/atoms/ChevronToggle.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'ActionButton',
  props: {
    action: {},
    showText: { type: Boolean, default: false },
    size: { default: 'small-icon' },
    invert: { type: Boolean, default: false },
    invertOnHover: { type: Boolean, default: true },
    chevron: { type: Boolean, default: false },
    tabIndex: { default: 0 },
    disabled: { type: Boolean, default: false },
    hoverBackgroundColor: { default: '#3F46D6' },
    stopClickPropagation: { type: Boolean, default: false }
  },
  emits: ["action"],
  setup(__props: any) {

_useCssVars(_ctx => ({
  "11332f04": (_unref(hoverBackgroundColor))
}))

const props = __props

const { hoverBackgroundColor } = toRefs(props)



const { t } = useI18n()

const hover = ref(false)

const shouldInvert = computed(
  () => props.invert || (hover.value && props.invertOnHover && !props.disabled)
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(TooltipStandardV2, {
    disabledTooltip: _ctx.showText,
    "arrow-position": "top-center",
    text: _unref(t)(_ctx.action.labelKey)
  }, {
    default: _withCtx(() => [
      _createVNode(ButtonText, {
        id: _ctx.action.actionName,
        class: _normalizeClass(['action-button', { disabled: _ctx.disabled }]),
        size: _ctx.size,
        disabled: _ctx.disabled,
        buttonText: _ctx.showText ? _unref(t)(_ctx.action.labelKey) : undefined,
        whiteContent: shouldInvert.value,
        tabIndex: _ctx.tabIndex,
        onMouseenter: _cache[0] || (_cache[0] = ($event: any) => (hover.value = true)),
        onMouseleave: _cache[1] || (_cache[1] = ($event: any) => (hover.value = false)),
        onDblclick: _cache[2] || (_cache[2] = 
        (e) => {
          e.stopPropagation()
        }
      ),
        onOnClicked: _cache[3] || (_cache[3] = 
        (e) => {
          _ctx.$emit('action', _ctx.action)
          if (_ctx.stopClickPropagation) {
            e.stopPropagation()
          }
        }
      )
      }, {
        left: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.action.icon), {
              class: "icon",
              focusable: "false",
              style: _normalizeStyle({
              color: shouldInvert.value ? 'white' : 'inherit'
            })
            }, null, 8, ["style"]))
          ])
        ]),
        right: _withCtx(() => [
          (_ctx.chevron)
            ? (_openBlock(), _createBlock(ChevronToggle, {
                key: 0,
                state: 'down',
                invert: shouldInvert.value
              }, null, 8, ["invert"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["id", "class", "size", "disabled", "buttonText", "whiteContent", "tabIndex"])
    ]),
    _: 1
  }, 8, ["disabledTooltip", "text"]))
}
}

})